/**
 * Whether a screen that opted into the Day/Night modes is mounted (`PaseScope`; docs/decisions/2026-10-31-panel-day-and-night-modes.md).
 * The only piece of the modes in the Panel's entry: the shell reads it to draw the switch. The store of the choice, the
 * switch and the tokens (`mode.ts`, `theme-switch.tsx`, `pase.scss`) load in chunks of their own.
 */

let optedIn = false;
const listeners = new Set<() => void>();

export const paseOptedIn = (): boolean => optedIn;

export function setPaseOptedIn(next: boolean): void {
  optedIn = next;
  for (const listener of listeners) listener();
}

export function subscribePaseOptIn(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
